<!--
 * @Author: your name
 * @Date: 2020-12-04 10:27:53
 * @LastEditTime: 2020-12-10 19:00:00
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /unicom_back_dev_20200628/src/views/applicationManagement/qualitySafety/resourceManage/componments/saveNewTemplate.vue
-->
<template>
  <div>
    <el-dialog title="修改模版名称" :visible.sync="isShowWIndow" @close="cancleMenthod">
      <el-input placeholder="请输入模版名称" v-model="templateName" clearable> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancleMenthod" style="margin-right: 15px">取 消</el-button>
        <el-button type="primary" @click="confirmAdd">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { PAGE_SIZE, PAGE_SIZES } from '@/lib/constants';
import Axios from '@/lib/axios';
import API from '@/lib/apiList';
export default {
  props: {
    isshow: Boolean,
    currentTemplate: Object
  },
  data() {
    return {
      templateName: '', //新模版名称
      isShowWIndow: this.isshow
    };
  },
  watch: {
    isshow(val) {
      this.isShowWIndow = val;
    },
    currentTemplate(val) {
      if (val) {
        this.templateName = val.modelName;
      }
    }
  },

  methods: {
    //关闭弹窗
    cancleMenthod() {
      this.$emit('closeWindow', {});
    },

    //确认提交
    confirmAdd() {
      if (this.templateName.length <= 0) {
        this.$message.error('请填写模版名称');
        return;
      }
      this.editeTemeteRequest();
    },

    /** 修改名称 */
    editeTemeteRequest() {
      let that = this;
      Axios.requestWWWForm({
        url: '/unicom/qclandarea/updateAreaModelName',
        data: {
          projectId: this.$cookies.get('PROJECT_ID'),
          modelId: this.currentTemplate.modelId,
          modelName: this.templateName
        }
      })
        .then(res => {
          if (res.data.code === '1000') {
            this.$message.success('修改模版名称成功');
            this.$emit('confirmWindow', {});
          } else {
            that.$message.error(res.data.msg);
          }
        })
        .catch(err => {
          that.$message.error(err);
        });
    }
  }
};
</script>

<style lang="less" scoped></style>>
